export const BUNDLES = 'BUNDLES'
export const BUNDLE = 'BUNDLE'
export const BUNDLE_CHARTS = 'BUNDLE_CHARTS'
export const BUNDLE_USAGE_HISTORY = 'BUNDLE_USAGE_HISTORY'
export const BUNDLE_USAGE_HISTORY_SUMMARY = 'BUNDLE_USAGE_HISTORY_SUMMARY'

export default {
    BUNDLES,
    BUNDLE,
    BUNDLE_CHARTS,
    BUNDLE_USAGE_HISTORY,
    BUNDLE_USAGE_HISTORY_SUMMARY,
}